import * as React from 'react';

import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

import { SlatePlugin } from '../../slatePlugins/slatePlugins.types';
import { ShortAnswerBlank } from '../blank-plugin/components/ShortAnswerBlank';
import {
  EXERCISE_SHORT_ANSWER,
  EXERCISE_SHORT_ANSWER_BLANK,
  EXERCISE_SHORT_ANSWER_QUESTION,
  EXERCISE_SHORT_ANSWER_QUESTIONS,
  PARAGRAPH_TOGGLE,
  EditorExerciseShortAnswerQuestionsOptions
} from './types';

const ShortAnswerElement = dynamicEditorComponent(() =>
  import('./components/ShortAnswerElement').then(
    (mod) => mod.ShortAnswerElement,
  ),
);

const ShortAnswerQuestions = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(
    () => import('./components/ShortAnswerQuestions').then((mod) => mod.ShortAnswerQuestions),
    {
      dependsOn: ShortAnswerElement,
    },
  ),
);
const ShortAnswerQuestion = withDynamicBlogEditorPluginHydration({
  canInteract: true,
})(
  dynamicEditorComponent(() => import('./components/ShortAnswerQuestion').then((mod) => mod.ShortAnswerQuestion),
    {
      dependsOn: ShortAnswerElement,
    },
  ),
);

const ShortAnswerParagraphToggle = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(
    () => import('./components/ShortAnswerParagraphToggle').then((mod) => mod.ShortAnswerParagraphToggle),
    {
      dependsOn: ShortAnswerElement,
    },
  ),
);
const renderElementEditorExerciseShortAnswer = (options: EditorExerciseShortAnswerQuestionsOptions) => (props) => {
  const { element } = props;

  switch (element.type) {
    case PARAGRAPH_TOGGLE: {
      if (element.parentNodeType !== EXERCISE_SHORT_ANSWER) return undefined;
      return <ShortAnswerParagraphToggle {...props} {...options} />;
    }

    case EXERCISE_SHORT_ANSWER:
      return <ShortAnswerElement {...props} {...options}/>;

    case EXERCISE_SHORT_ANSWER_QUESTIONS:
      return <ShortAnswerQuestions {...props} {...options} />;

    case EXERCISE_SHORT_ANSWER_QUESTION:
      return <ShortAnswerQuestion {...props} />;

    case EXERCISE_SHORT_ANSWER_BLANK:
      return <ShortAnswerBlank {...props} {...options} />;

    default:
      return undefined;
  }
};

export const EditorExerciseShortAnswerPlugin = (
  options?: EditorExerciseShortAnswerQuestionsOptions,
): SlatePlugin => {
  return {
    renderElement: renderElementEditorExerciseShortAnswer(options),
  };
};
